import loadable from '@loadable/component';
import { useTracking } from 'react-tracking';
import { useMyScreeners } from '../hooks/useMyScreeners';
import { TableRowScreenerUser } from './TableRowScreenerUser';
import { Table } from './Table';

const ScreenersEmpty = loadable(() => import('./ScreenersEmpty'), {
  resolveComponent: (module) => module.ScreenersEmpty,
});

export const Screeners = () => {
  const { data } = useMyScreeners();
  const { predefinedUserScreenerSummary } = data;
  const { Track } = useTracking({
    type: 'track',
    subject: 'myScreenersModule',
  });

  if (predefinedUserScreenerSummary.length === 0) return <ScreenersEmpty />;

  return (
    <Track>
      <Table>
        <Table.HeadFake />
        <Table.Head />
        <Table.Body>
          {predefinedUserScreenerSummary.map((screener) => (
            <TableRowScreenerUser key={screener.id} {...screener} />
          ))}
        </Table.Body>
        <Table.Foot />
      </Table>
    </Track>
  );
};
